export var CODIGO_PERGUNTA_ORIGEM = 71;
export var CODIGO_PERGUNTA_MIDIA = 72;
export var CODIGO_PERGUNTA_CAMPANHA = 73;

export var CORES_GRAFICOS = [
  'rgba(54, 162, 235, 0.8)',
  'rgba(255, 99, 132, 0.8)',
  'rgba(75, 192, 192, 0.8)',
  'rgba(255, 206, 86, 0.8)',
  'rgba(153, 102, 255, 0.8)',
  'rgba(255, 159, 64, 0.8)',
  'rgba(199, 199, 199, 0.8)',
  'rgba(83, 102, 255, 0.8)',
  'rgba(255, 99, 71, 0.8)',
  'rgba(60, 179, 113, 0.8)',
];

export var CORES_PIZZA = [
  'rgba(54, 162, 235, 0.8)',
  'rgba(255, 99, 132, 0.8)',
  'rgba(75, 192, 192, 0.8)',
  'rgba(255, 206, 86, 0.8)',
  'rgba(153, 102, 255, 0.8)',
  'rgba(255, 159, 64, 0.8)',
  'rgba(199, 199, 199, 0.8)',
  'rgba(83, 102, 255, 0.8)',
  'rgba(255, 99, 71, 0.8)',
  'rgba(60, 179, 113, 0.8)',
];
